'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
interface CartItem {
  giftCartItemOptionId: number;
  quantity: number;
  itemTotalPrice: number;
  soldOutYN?: boolean;
}
interface UseCartSelectionParams<T extends CartItem> {
  items: T[];
  totalPrice: number;
}
interface UseCartSelectionReturn {
  selectedIds: Set<number>;
  selectedCount: number;
  selectedTotalAmount: number;
  isAllSelected: boolean;
  select: (giftCartItemOptionId: number) => void;
  selectAll: () => void;
  deselect: (giftCartItemOptionId: number) => void;
  deselectAll: () => void;
}
export const useCartSelection = t0 => {
  const $ = _c(33);
  const {
    items,
    totalPrice
  } = t0;
  const [selectedIds, setSelectedIds] = useState(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const prevItemIdsRef = useRef(t1);
  let t2;
  let t3;
  if ($[1] !== items) {
    t2 = () => {
      if (items.length === 0) {
        return;
      }
      const currentItemIds = new Set(items.map(_temp2));
      const prevItemIds = prevItemIdsRef.current;
      const newItemIds = items.filter(item_0 => !prevItemIds.has(item_0.giftCartItemOptionId) && !item_0.soldOutYN).map(_temp3);
      const soldOutIds = new Set(items.filter(_temp4).map(_temp5));
      const hasNewItems = newItemIds.length > 0;
      const hasDeletedItems = [...prevItemIds].some(id => !currentItemIds.has(id));
      if (hasNewItems || hasDeletedItems || soldOutIds.size > 0) {
        setSelectedIds(prev => {
          const newSet = new Set(prev);
          for (const id_0 of prev) {
            if (!currentItemIds.has(id_0)) {
              newSet.delete(id_0);
            }
          }
          for (const id_1 of soldOutIds) {
            newSet.delete(id_1);
          }
          for (const id_2 of newItemIds) {
            newSet.add(id_2);
          }
          return newSet;
        });
      }
      prevItemIdsRef.current = currentItemIds;
    };
    t3 = [items];
    $[1] = items;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== items) {
    t4 = items.filter(_temp6);
    $[4] = items;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const selectableItems = t4;
  let t5;
  if ($[6] !== selectableItems || $[7] !== selectedIds) {
    t5 = selectableItems.length > 0 && selectableItems.every(item_5 => selectedIds.has(item_5.giftCartItemOptionId));
    $[6] = selectableItems;
    $[7] = selectedIds;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const isAllSelected = t5;
  let t6;
  if ($[9] !== items || $[10] !== selectedIds) {
    let t7;
    if ($[12] !== selectedIds) {
      t7 = item_6 => selectedIds.has(item_6.giftCartItemOptionId);
      $[12] = selectedIds;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    t6 = items.filter(t7).reduce(_temp7, 0);
    $[9] = items;
    $[10] = selectedIds;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const selectedCount = t6;
  let t7;
  if ($[14] !== isAllSelected || $[15] !== items || $[16] !== selectedIds || $[17] !== totalPrice) {
    t7 = isAllSelected ? totalPrice : items.filter(item_8 => selectedIds.has(item_8.giftCartItemOptionId)).reduce(_temp8, 0);
    $[14] = isAllSelected;
    $[15] = items;
    $[16] = selectedIds;
    $[17] = totalPrice;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const selectedTotalAmount = t7;
  let t8;
  if ($[19] !== items) {
    t8 = giftCartItemOptionId => {
      const item_10 = items.find(i => i.giftCartItemOptionId === giftCartItemOptionId);
      if (item_10?.soldOutYN) {
        return;
      }
      setSelectedIds(prev_0 => {
        const newSet_0 = new Set(prev_0);
        if (newSet_0.has(giftCartItemOptionId)) {
          newSet_0.delete(giftCartItemOptionId);
        } else {
          newSet_0.add(giftCartItemOptionId);
        }
        return newSet_0;
      });
    };
    $[19] = items;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const select = t8;
  let t9;
  if ($[21] !== isAllSelected || $[22] !== selectableItems) {
    t9 = () => {
      if (isAllSelected) {
        setSelectedIds(new Set());
      } else {
        setSelectedIds(new Set(selectableItems.map(_temp9)));
      }
    };
    $[21] = isAllSelected;
    $[22] = selectableItems;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const selectAll = t9;
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = giftCartItemOptionId_0 => {
      setSelectedIds(prev_1 => {
        const newSet_1 = new Set(prev_1);
        newSet_1.delete(giftCartItemOptionId_0);
        return newSet_1;
      });
    };
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const deselect = t10;
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      setSelectedIds(new Set());
    };
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const deselectAll = t11;
  let t12;
  if ($[26] !== isAllSelected || $[27] !== select || $[28] !== selectAll || $[29] !== selectedCount || $[30] !== selectedIds || $[31] !== selectedTotalAmount) {
    t12 = {
      selectedIds,
      selectedCount,
      selectedTotalAmount,
      isAllSelected,
      select,
      selectAll,
      deselect,
      deselectAll
    };
    $[26] = isAllSelected;
    $[27] = select;
    $[28] = selectAll;
    $[29] = selectedCount;
    $[30] = selectedIds;
    $[31] = selectedTotalAmount;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
function _temp() {
  return new Set();
}
function _temp2(item) {
  return item.giftCartItemOptionId;
}
function _temp3(item_1) {
  return item_1.giftCartItemOptionId;
}
function _temp4(item_2) {
  return item_2.soldOutYN;
}
function _temp5(item_3) {
  return item_3.giftCartItemOptionId;
}
function _temp6(item_4) {
  return !item_4.soldOutYN;
}
function _temp7(sum, item_7) {
  return sum + item_7.quantity;
}
function _temp8(sum_0, item_9) {
  return sum_0 + item_9.itemTotalPrice;
}
function _temp9(item_11) {
  return item_11.giftCartItemOptionId;
}